import { Anchor, Center, Group, Tooltip } from '@mantine/core'
import { faArrowUpRightFromSquare } from '@fortawesome/sharp-duotone-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { openExternalUrl } from '../../utils/openExternalUrl'

// The same in every environment, so it lives in code; VITE_VISION_URL can still override it.
// `||` rather than `??` so an empty value falls back too.
const VISION_URL = import.meta.env.VITE_VISION_URL || 'https://vision.mclarens.com/visionclient/#'

// What the Time Entry tab shows a user without a Replicon account: they record time in
// Vision instead, so the tab is just the way there.
export function VisionLink() {
  return (
    <Center>
      <Tooltip label="Open Vision" withArrow>
        <Anchor
          component="button"
          type="button"
          fz="sm"
          c="var(--link-color)"
          onClick={() => openExternalUrl(VISION_URL)}
        >
          <Group gap={4} wrap="nowrap" component="span">
            Open Vision
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
          </Group>
        </Anchor>
      </Tooltip>
    </Center>
  )
}
